import { DisplayOptions } from './display-options';

export default DisplayOptions;
